<property-tabs (tabChanged)="tabChanged($event)">
  <router-outlet></router-outlet>
  <div class="buttons mx-4 mb-4 is-justify-content-end pt-4">
    <button
      [disabled]="isLoading"
      type="button"
      (click)="save()"
      class="button is-success"
      translationEditableDirective="SAVE"
    >
      {{ 'SAVE' | translate }}
    </button>
    <div class="control">
      <a
        [routerLink]="['/properties']"
        class="delete"
        translationEditableDirective="CANCEL"
      >
      </a>
    </div>
  </div>
</property-tabs>
